import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { SchemaUpdates } from "plugins/schema-updates/schema-updates"
import { PRIORITY_DATA, SECTION_DATA } from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

registerSystemAdminTab(
    "Schema Updates",
    <SchemaUpdates $lazy />,
    undefined,
    PRIORITY_DATA,
    "mdi:database-sync",
    SECTION_DATA
)
